<template>
  <div class="relative lg:overflow-hidden lg:p-1">
    <ProductImageGalleryNew
      v-if="!isMobile"
      :images="product.images"
      :product-name="productName"
      :product-order-number="productOrderNumber"
      @click:image="toggleZoomGallery(true, $event)"
    />
    <ProductImageGallery
      v-if="isMobile"
      :images="product.images"
      :product-name="productName"
      :product-order-number="productOrderNumber"
      @click:image="toggleZoomGallery(true, $event)"
    />
    <LazyZoomGallery
      v-if="zoomGallery.display"
      :images="product.images"
      :product-name="productName"
      :active-index="zoomGallery.index"
      @click:close-zoom-gallery="toggleZoomGallery(false)"
    />
  </div>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'
import type { HyphenatedOrderNumber } from '~/types/product'
import { useDeviceType } from '~/composables/useDeviceType'
import useZoomGalleryActions from '#layers/base/composables/ui/useZoomGalleryActions'

defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  productName: {
    type: String,
    required: true,
  },
  productOrderNumber: {
    type: String as PropType<HyphenatedOrderNumber>,
    default: '',
  },
})

defineEmits(['click:image', 'close:zoom-gallery'])

const { isMobile } = useDeviceType()

const { state: zoomGallery, toggle } = useZoomGalleryActions()

const toggleZoomGallery = (isOpen: boolean, index?: number) => {
  toggle(isOpen, index)
}
</script>
